import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SearchQueryState {
  searchQuery: string;
}

const searchQuerySlice = createSlice({
  name: "searchQuery",
  initialState: {
    searchQuery: ""
  } as SearchQueryState, // Provide the initial state with a valid type
  reducers: {
    setVariable: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    }
  }
});

export const { setVariable } = searchQuerySlice.actions;

export default searchQuerySlice.reducer;
